import React from 'react'
import { Button, Dialog, Typography, useViewport } from '@chilecompra/react-kit'
import { GridContainer, GridItem, RootContainer, ExclamationIcon } from './ErrorParticipantModal.styles'
import { useDispatch, useSelector } from 'react-redux'
import { onSetErrorModalSuccess } from './ErrorParticipantModal.actions'
import { PUBLIC_URL } from '../../config/settings/environment'

/**
 * The Error Participant modal container.
 */
const ErrorParticipantModalContainer = () => {
  const dispatch = useDispatch()
  const { showErrorParticipantModal, errorMessages, errorTitle } = useSelector(state => state.errorParticipantModal)

  const {
    size: { isDownToMedium }
  } = useViewport()

  const handleCloseModal = () => {
    dispatch(onSetErrorModalSuccess({ showErrorParticipantModal: false }))
  }

  const handleSubmit = () => {
    dispatch(onSetErrorModalSuccess({ showErrorParticipantModal: false, errorMessages: [], errorTitle: '' }))
  }

  return (
    <Dialog
      open={showErrorParticipantModal}
      onClose={handleCloseModal}
      margin="0 20px"
      padding="0px"
      maxWidth="750px"
      disableBackdropClick
    >
      <RootContainer justifyContent="center">
        <GridItem xs={12} container justifyContent="center">
          <ExclamationIcon src={`${PUBLIC_URL}/assets/images/alert_icon.svg`} />
        </GridItem>
        <GridItem xs={12} padding="37px 0 0">
          <Typography fontSize="18px" color="black1" fontWeight="bold" variant="h3" align="center">
            {errorTitle}
          </Typography>
        </GridItem>
        <GridItem xs={12} md={8} padding="27px 0 0">
          {errorMessages &&
            errorMessages.length > 0 &&
            errorMessages.map((textElement, index) => (
              <Typography
                key={`error-N-${index}`}
                fontSize={isDownToMedium ? '14px' : '16px'}
                color="black1"
                fontWeight="regular"
                variant="h3"
                align="center"
              >
                {textElement}
              </Typography>
            ))}
        </GridItem>
        <GridItem xs={12} padding="48px 0 0">
          <GridContainer justifyContent="center">
            <GridItem xs={12} container justifyContent="center">
              <Button onClick={handleSubmit} color="primary">
                Aceptar y continuar
              </Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </RootContainer>
    </Dialog>
  )
}

export default ErrorParticipantModalContainer
